import { render, staticRenderFns } from "./IncrementalRevenueEmptyState.vue?vue&type=template&id=a51f4f5a&scoped=true"
import script from "./IncrementalRevenueEmptyState.vue?vue&type=script&lang=js"
export * from "./IncrementalRevenueEmptyState.vue?vue&type=script&lang=js"
import style0 from "./IncrementalRevenueEmptyState.vue?vue&type=style&index=0&id=a51f4f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51f4f5a",
  null
  
)

export default component.exports